export default function CadastroCliente(){
    return (
        "Cadastro Cliente"
    );
}